(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HEIR-drop-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeHeirDropHero(root) {
    const heroes = root.querySelectorAll('.heir-drop-hero');

    heroes.forEach(function (hero) {
      if (hero.dataset.autoRevealInitialized === 'true') {
        return;
      }

      hero.dataset.autoRevealInitialized = 'true';

      let revealTimer = null;

      function revealSecondImage() {
        hero.classList.add('is-revealed');
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!revealTimer) {
                revealTimer = window.setTimeout(function () {
                  revealSecondImage();
                  observer.unobserve(hero);
                }, 2000);
              }
            } else if (revealTimer) {
              window.clearTimeout(revealTimer);
              revealTimer = null;
            }
          });
        },
        {
          threshold: 0.35
        }
      );

      observer.observe(hero);

      hero.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) {
          return;
        }

        if (revealTimer) {
          window.clearTimeout(revealTimer);
          revealTimer = null;
        }

        revealSecondImage();
        observer.unobserve(hero);
      });
    });
  }

  function initializePage() {
    initializeHeirDropHero(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage);
  } else {
    initializePage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeHeirDropHero(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
